import { DisplayFormatProvider } from '@luminovo/data-stack';
import { DefaultSnackbarProviderProps, NavigationGuardProvider } from '@luminovo/design-system';
import { SnackbarProvider } from 'notistack';
import React from 'react';

import { GlobalQueryErrorHandler } from '@/shared/data/contexts/GlobalQueryErrorHandler';

import { StaleAppReloadPrompt } from './StaleAppReloadPrompt';

/** Providers every page sits under, inside the router. Keep nesting and element types: changes remount the app. */
export function AppProviders({ children }: { children: React.ReactNode }): JSX.Element {
    return (
        <NavigationGuardProvider>
            <SnackbarProvider {...DefaultSnackbarProviderProps}>
                <StaleAppReloadPrompt />
                {/* Before the pages, so their queries' errors find the handler in place. */}
                <GlobalQueryErrorHandler />
                <DisplayFormatProvider>{children}</DisplayFormatProvider>
            </SnackbarProvider>
        </NavigationGuardProvider>
    );
}
